import React from "react";
import AddEmpresaForm from "./AddEmpresaForm";

const AddEmpresa = ({ show, setShow }) => {
  const handleShow = () => {
    setShow(!show);
  };
  return (
    <>
      <div className="">
        <button className="btn btn-dark" onClick={handleShow}>
          {show ? "Ocultar Form" : "Agregar Empresa"}
        </button>
      </div>
      {show && (
        <div className="mt-2">
          <AddEmpresaForm setShow={setShow} />
        </div>
      )}
    </>
  );
};
export default AddEmpresa;
